import Head from 'next/head'
import { ToastContainer } from 'react-toastify'
import { useEffect, useState } from 'react'
import { useQuery, useMutation } from '@apollo/client/react'

import Header from '@/components/newHeader/Header'
import Cover from '@/components/referral/Cover'
import Steps from '@/components/referral/Steps'
import Footer from '@/components/newFooter/newFooter'
import Loader from '@/components/newLoader/Loader'

import { IGetAmbassadorResponse, VerifyAmbassadorEmailResponse } from '@types'
import { getToken, getUserData } from '@utils'
import { GET_AMBASSADOR, VERIFY_AMBASSADOR_EMAIL } from '@graphql'
import { ROBOTS_META } from 'const'

import styles from './referral.module.scss'

import sharedImage from '../../public/referral/gift-puppy.png'

export default function Referral({ identify }) {
  // HANDLE IS AMBASSADOR HAVE OR NOT EMAIL VERIFIED
  const [isOpen, setIsOpen] = useState(false)
  const [queryHash, setQueryHash] = useState<string>()
  const [ambassadorId, setAmbassadorId] = useState<number>()
  // Get user data
  const [userData, setUserData] = useState(null)

  useEffect(() => {
    const _userData = getUserData(getToken())
    if (_userData) setUserData(_userData)
  }, [])

  // HANDLE SHOW EMAIL VERIFIED BANNER
  function handleShowBanner() {
    setIsOpen(true)
    setTimeout(() => {
      setIsOpen(false)
    }, 4000)
  }

  const [verify, { loading: emailVerifying }] =
    useMutation<VerifyAmbassadorEmailResponse>(VERIFY_AMBASSADOR_EMAIL)

  useEffect(() => {
    if (identify !== undefined) {
      verify({
        variables: {
          hash: identify,
        },
      }).then((result) => {
        setQueryHash(result?.data?.verifyAmbassadorEmail.hash)
        setAmbassadorId(result?.data?.verifyAmbassadorEmail.id)
        handleShowBanner()
      })
    }
  }, [identify])

  const { data } = useQuery<IGetAmbassadorResponse>(GET_AMBASSADOR, {
    variables: { hash: queryHash },
  })

  const ambassadorData = data?.getAmbassador.find((elem) => elem.id === ambassadorId)

  // Meta tags values

  const TITLE = 'Referral | MawooPets.com'
  const DESCRIPTION =
    'For every friend you refer to Mawoo Pets, you’ll get a $50 Amazon gift card and they’ll get $50 off their puppy purchase!'
  const IMAGE = `${process.env.NEXT_PUBLIC_ROOT_URL}/mawoo_social_1600x906.png`
  const URL = `${process.env.NEXT_PUBLIC_ROOT_URL}/`
  const CANONICAL = `${process.env.NEXT_PUBLIC_ROOT_URL}/`

  return (
    <div>
      <Head>
        {/*  Facebook tags  */}
        <meta property="og:title" content={TITLE} key="title" />
        <meta name="og:description" content={DESCRIPTION} key="description" />
        <meta property="og:type" content="website" key="type" />
        <meta property="og:url" content={URL} key="url" />
        <meta property="og:image" content={IMAGE} key="image" />
        <meta name="og:locale" content="en_US" key="locale" />
        <meta
          property="og:image"
          content={`${process.env.NEXT_PUBLIC_MEDIA_BUCKET}${sharedImage}`}
          key="image"
        />
        <meta
          name="og:image:url"
          content={`${process.env.NEXT_PUBLIC_MEDIA_BUCKET}${sharedImage}`}
          key="imageUrl"
        />
        {/*  twitter tags  */}
        <meta name="twitter:card" content="summary_large_image" key="twitterCard" />
        <meta name="twitter:title" content={TITLE} key="twitterTitle" />
        <meta name="twitter:description" content={DESCRIPTION} key="twitterDescription" />
        <meta
          name="twitter:image"
          content={`${process.env.NEXT_PUBLIC_MEDIA_BUCKET}${sharedImage}`}
          key="twitterImage"
        />
        {/*  standard tags  */}
        <title>{TITLE}</title>
        <link rel="canonical" href={CANONICAL} />
        <meta name="description" content={DESCRIPTION} />
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        <meta name="robots" content={ROBOTS_META} />
      </Head>
      <ToastContainer
        position="bottom-left"
        autoClose={false}
        closeButton={false}
        closeOnClick={false}
        limit={1}
      />
      <div className={styles.main}>
        <Header />
        {emailVerifying && (
          <div className={styles.loader}>
            {' '}
            <Loader theme="tall" />{' '}
          </div>
        )}

        {isOpen && ambassadorData && !userData && (
          <section className={styles.verifiedModal}>
            <div>Thanks for verifying your email</div>
            <div
              className={styles.closeButton}
              onClick={() => {
                setIsOpen(false)
              }}
            >
              <img src="/btn-close-white.svg" alt="close icon" />
            </div>
          </section>
        )}
        <Cover ambassadorData={ambassadorData} />
        <Steps ambassadorData={ambassadorData} />
        <Footer />
      </div>
    </div>
  )
}
